import {AbstractControl, FormControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function modelYearValidator(): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
        const minYear = 1886;
        const curYear = new Date().getFullYear();
        const input = Number(control.value);

        if (!Number.isNaN(input) && Number.isInteger(input) && input >= minYear && input <= curYear) {
            return null;
        } else {
            return { 'modelYear': { value: control.value } };
        }
    };

}
